import React from 'react';

import { SvgIcon } from 'components/icons/SvgIcon';

type Props = {
  onDoneClick: () => void;
  enabled: boolean;
};

export const GiftWidgetSuccess = ({ onDoneClick, enabled }: Props) => (
  <div className='d-flex flex-column h-100'>
    <div className='h-100 pos-rel'>
      <div className='translate-into-middle nowrap'>
        <SvgIcon icon='checkmark' className='mr-mini fs-32 vam' />
        <span className='key-value key-value__value pos-rel' style={{ top: 1 }}>
          Artwork was gifted
        </span>
      </div>
    </div>
    <div>
      <button disabled={!enabled} onClick={onDoneClick} className='btn btn--border-dark w-100'>
        Done
      </button>
    </div>
  </div>
);
